
const colors = {
    black: '#2e2e2e',
    white: '#ffffff',
    darkGray: '#5e5e5e',
    lightGray: '#7b7b7b',
    personality: '#eda550'
}

export default colors;